<template>
  <modal name="add-fusebox-group" adaptive height="auto" @opened="clearForm" @closed="$emit('clearEdit')">
    <Wrapper>
      <template v-slot:header-title>
        <i class="icon--edit" v-if="edit"></i>
        <i class="icon--plus" v-else></i>
        {{ (edit ? $t('fusebox.edit_group') : $t('fusebox.add_a_new_group')) }}
      </template>
      <ValidationObserver ref="observer" v-slot="{ invalid }" tag="form" class="form__wrapper">
        <div class="field__flex">
          <Field :label="$t('fusebox.group_form.order_no')"
                 name="order_no"
                 rules="required|max:255"
                 type="text"
                 v-model="form.order_no"/>
          <Field :label="$t('fusebox.group_form.group_name')"
                 name="group_name"
                 rules="required|max:255"
                 type="text"
                 v-model="form.name"/>
        </div>
        <div class="field__row">
        </div>
        <div class="field__row">
          <Radio :radio="[
                   {
                      label: '1P',
                      value: 0,
                      name: 'phase',
                   },
                   {
                      label: '3P',
                      value: 1,
                      name: 'phase',
                   }
                 ]"
                 :radio-name="$t('fusebox.group_form.phase')"
                 rules="required"
                 v-model="form.phase"/>
        </div>
        <div class="field__row">
          <div class="field__flex">
            <FieldSelect :label="$t('fusebox.group_form.amperage')"
                         name="amperage"
                         :items="amperages"
                         v-model="form.amperage_id"/>
            <FieldSelect :label="$t('fusebox.group_form.characteristic')"
                         name="Characteristic"
                         :items="characteristics"
                         v-model="form.characteristic_id"/>
          </div>
        </div>
        <div class="field__row">
            <Textarea :label="$t('fusebox.group_form.additional_info')"
                      name="additional_info"
                      rules=""
                      :required="false"
                      type="text"
                      v-model="form.additional_info"/>
        </div>

        <div class="btn--bar">

          <template v-if="!edit">
            <button type="button" @click="save()" :disabled="invalid || submit" class="btn">
              <i class="icon--check"></i> {{ $t('general.save') }}
            </button>
          </template>
          <template v-else>
            <button type="button" @click="editForm()" :disabled="invalid || submit" class="btn">
              <i class="icon--check"></i> {{ $t('general.save') }}
            </button>
          </template>

          <span @click="$emit('hideModal')" class="btn btn--secondary">
            <i class="icon--cancel"></i> {{ $t('general.close') }}
          </span>
        </div>

        <!--        <div class="field__row&#45;&#45;btn">-->
        <!--          <span class="close" @click="$emit('hideModal')">{{ $t("general.close") }}</span>-->
        <!--          <template v-if="!edit">-->
        <!--            <button type="button" @click="save()" :disabled="invalid"-->
        <!--                    class="btn btn&#45;&#45;dark-grey btn&#45;&#45;right">-->
        <!--              {{ $t('general.save') }}-->
        <!--            </button>-->
        <!--          </template>-->
        <!--          <template v-else>-->
        <!--            <button type="button" @click="editForm()" :disabled="invalid"-->
        <!--                    class="btn btn&#45;&#45;dark-grey btn&#45;&#45;right">-->
        <!--              {{ $t('general.edit') }}-->
        <!--            </button>-->
        <!--          </template>-->
        <!--        </div>-->

      </ValidationObserver>
    </Wrapper>
  </modal>
</template>

<script>
import Field from '@/components/Parts/Field'
import Radio from '@/components/Parts/Radio'
import Textarea from '@/components/Parts/Textarea'
import FieldSelect from '@/components/Parts/FieldSelect'
import Wrapper from '@/components/Modal/Wrapper'
import { errHandler } from '@/helpers'

export default {
  name: 'Modal-Group',
  props: {
    edit: {
      type: [Boolean, Object],
      default: false
    },
    amperages: Array,
    characteristics: Array
  },
  components: {
    Wrapper,
    FieldSelect,
    Field,
    Radio,
    Textarea
  },
  data () {
    return {
      form: {
        order_no: '',
        name: '',
        phase: 0,
        amperage_id: '',
        characteristic_id: '',
        additional_info: ''
      },
      submit: false
    }
  },
  methods: {
    async save () {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        try {
          this.submit = true
          await this.$store.dispatch('fusebox/addGroup', {
            id: this.$route.params.id,
            form: this.form
          })
          this.$emit('hideModal')
          this.$emit('changeDate')
          this.$toasted.global.success_message({
            message: this.$t('fusebox.createGroupSuccess')
          })
        } catch (e) {
          errHandler(e, this.$toasted, key => this.$t(key))
        } finally {
          this.submit = false
        }
      }
    },
    async editForm () {
      if (await this.$refs.observer.validate()) {
        try {
          this.submit = true
          await this.$store.dispatch('fusebox/updateGroup', {
            id: this.$route.params.id,
            uuid: this.edit.uuid,
            form: this.form
          })
          this.$toasted.global.success_message({
            message: this.$t('fusebox.updateGroupSuccess')
          })
          this.$emit('hideModal')
          this.$emit('changeDate')
        } catch (e) {
          errHandler(e, this.$toasted, key => this.$t(key))
        } finally {
          this.submit = false
        }
      }
    },
    clearForm () {
      this.$nextTick(() => {
        if (!this.edit) {
          const sixtAmp = this.amperages.find(e => e.name === '16A')
          this.form = {
            order_no: '',
            name: '',
            phase: 0,
            amperage_id: sixtAmp !== undefined ? sixtAmp.id : '',
            characteristic_id: '',
            additional_info: ''
          }
        } else {
          this.form = {
            order_no: this.edit.order_no,
            name: this.edit.name,
            phase: this.edit.phase,
            amperage_id: this.edit.amperage_id,
            characteristic_id: this.edit.characteristic_id,
            additional_info: this.edit.additional_info
          }
        }

        requestAnimationFrame(() => {
          this.$refs.observer.reset()
        })
      })
    }
  }
}
</script>
